import { useState } from 'react'
import {
  Chip,
  Box,
  Menu,
  MenuItem,
  IconButton,
  TextField,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material'
import { TagCategory, TagSelectorProps } from '../CardView.types'
import AddIcon from '@mui/icons-material/Add'
import LabelIcon from '@mui/icons-material/Label'

export const TagSelector = ({
  tags = [],
  availableTags,
  onTagsChange,
  onAddCustomTag,
}: TagSelectorProps) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [customTagDialogOpen, setCustomTagDialogOpen] = useState(false)
  const [customTag, setCustomTag] = useState('')

  const handleTagClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleTagSelect = (tag: TagCategory) => {
    onTagsChange([tag])
    handleClose()
  }

  const handleTagDelete = (tagToDelete: TagCategory) => {
    onTagsChange([])
  }

  const handleCustomTagSubmit = () => {
    if (
      customTag.trim() &&
      !availableTags.includes(customTag) &&
      onAddCustomTag
    ) {
      onAddCustomTag(customTag.trim())
      onTagsChange([customTag.trim()])
      setCustomTag('')
    }
    setCustomTagDialogOpen(false)
  }

  return (
    <Box
      sx={{ display: 'flex', flexWrap: 'wrap', gap: 0.5, alignItems: 'center' }}
    >
      {tags.map((tag, index) => (
        <Chip
          key={index}
          label={tag}
          color="info"
          variant="filled"
          size="small"
          onDelete={() => handleTagDelete(tag)}
          sx={{ color: 'white' }}
        />
      ))}

      {tags.length < 1 ? (
        <IconButton size="small" onClick={handleTagClick}>
          <LabelIcon fontSize="small" />
        </IconButton>
      ) : null}

      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {availableTags.map((tag, index) => (
          <MenuItem
            key={index}
            onClick={() => handleTagSelect(tag)}
            disabled={tags.includes(tag)}
          >
            {tag}
          </MenuItem>
        ))}
        <MenuItem
          onClick={() => {
            handleClose()
            setCustomTagDialogOpen(true)
          }}
        >
          <AddIcon fontSize="small" sx={{ mr: 1 }} />
          Add Custom Tag
        </MenuItem>
      </Menu>

      <Dialog
        open={customTagDialogOpen}
        onClose={() => setCustomTagDialogOpen(false)}
      >
        <DialogTitle>Add Custom Tag</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            margin="dense"
            label="Tag Name"
            fullWidth
            variant="outlined"
            value={customTag}
            onChange={(e) => setCustomTag(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setCustomTagDialogOpen(false)}>Cancel</Button>
          <Button onClick={handleCustomTagSubmit}>Add</Button>
        </DialogActions>
      </Dialog>
    </Box>
  )
}

export default TagSelector
